module.exports = __webpack_public_path__ + "static/images/components/RewardMoney/images/bonds-large.262438e3.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardMoney/images/bonds-large.png
// module id = 2667
// module chunks = 11